import React from "react";
import './FooterRoutes.css'; // Import the stylesheet

export default function IPDMeasurementGuide() {
  return (
    <div className="container">
      <h1 className="title">How to Measure IPD?</h1>
      <div className="section">
        <h2 className="subtitle">What is IPD?</h2>
        <p>
          Interpupillary Distance (IPD) is the distance between the centers of your pupils, and it plays a crucial role in ensuring that your eyeglasses provide optimal vision correction. Having an accurate IPD measurement is essential when ordering eyewear online to guarantee the proper alignment of the lenses with your eyes.
        </p>
      </div>

      <div className="section">
        <h2 className="subtitle">Step-by-Step Guide to Measure Your IPD:</h2>
        <ol>
          <li>
            <p className="step-title">Gather Materials:</p>
            <ul>
              <li>A ruler with millimeter markings.</li>
              <li>A mirror.</li>
              <li>A friend or family member to assist (optional).</li>
            </ul>
          </li>
          <li>
            <p className="step-title">Stand in Front of the Mirror:</p>
            Position yourself at a comfortable distance from the mirror, ensuring good lighting.
          </li>
          <li>
            <p className="step-title">Hold the Ruler:</p>
            Hold the ruler horizontally against your brow, ensuring it is straight and level.
          </li>
          <li>
            <p className="step-title">Look Straight Ahead:</p>
            Focus on a spot directly in front of you, keeping your head straight and level.
          </li>
          <li>
            <p className="step-title">Measure the Distance:</p>
            <ul>
              <li>
                If you have a friend or family member assisting, have them measure the distance between the centers of your pupils in millimeters. Ensure the ruler is positioned at the center of one pupil, and the measurement is taken to the center of the other pupil.
              </li>
              <li>
                If you are measuring on your own, look directly into the mirror and measure from the center of one pupil to the center of the other using the millimeter markings on the ruler.
              </li>
            </ul>
          </li>
          <li>
            <p className="step-title">Record the Measurement:</p>
            Note down the measurement. This is your IPD.
          </li>
        </ol>
      </div>

      <div className="section">
        <h2 className="subtitle">Why is Accurate IPD Important?</h2>
        <p>
          Having an accurate IPD measurement ensures that your eyeglasses provide the correct alignment for your eyes. Proper alignment is crucial for optimal vision correction, reducing eye strain, and enhancing the overall comfort of wearing your eyewear.
        </p>
      </div>

      <div className="section">
        <h2 className="subtitle">Ordering Eyewear Online:</h2>
        <p>
          When you've successfully measured your IPD, you can confidently order eyewear online. Many online eyewear retailers provide an option to enter your IPD during the ordering process, ensuring that your glasses are customized for your unique facial features.
        </p>
        <p>
          By following these simple steps to measure your IPD at home or in the office, you empower yourself to make informed decisions when ordering eyewear online. Enjoy the convenience of online shopping with us while ensuring that your new glasses provide the perfect fit for clear and comfortable vision.
        </p>
      </div>
    </div>
  );
}
